<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title"> {{'app.editTile' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save()">
        <div class="row padding-sm-vr" *ngFor="let item of configurations; let i = index">

          <div class="col-sm-4">
            <div>
              <label class="control-label">{{'Coloumn Name' | translate}} </label>
              <input type="text"
                     name="name{{i}}"
                     [(ngModel)]="item.columnName"
                     #name="ngModel"
                     disabled
                     class="form-control" />

            </div>
          </div>
          <div class="col-sm-4">
            <div>
              <label class="control-label">{{'Display Name' | translate}} </label>
              <input type="text"
                     name="displayName{{i}}"
                     [(ngModel)]="item.displayName"
                     #displayName="ngModel"
                      
                     class="form-control" />

            </div>
          </div>
          <div class="col-sm-4" style="margin-top:1%">
            <div class="pull-left">
              <div class="checkbox user-enabled">
                <label  >
                  <input type="checkbox" name="isHidden{{i}}" [(ngModel)]="item.isHidden">
                  Hidden
                </label>
              </div>

            </div>
          </div>

        </div>
          

        

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" [disabled]="f.invalid">{{'app.save' | translate}}</button>

        </div>

      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




